import React, { useEffect } from 'react';
import './app.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import homeRoute from '@routes/Home';
import { ConfigProvider } from 'antd';
import NotFound from '@components/NotFound';
import { initializeStore } from '@store/store';
import { Provider } from 'react-redux';
import { fetchSubDomain } from '@utils/urlHelpers';
import { ApolloProvider } from '@apollo/client';
import client from '@/lib/apolloClient';
import { getCentrifugoClient } from '@/lib/centrifugoClient';
import { CentrifugoProvider } from '@/Components/Centrifugo';

export const getRouter = ({ subDomain, store }) => {
	const routeConfig = subDomain
		? homeRoute(store)
		: [
				{
					path: '/',
					element: <NotFound />,
				},
			];
	const router = createBrowserRouter(routeConfig);

	return router;
};

const subDomain = fetchSubDomain();

const store = initializeStore();

const centrifuge = getCentrifugoClient();

const CentrifugoConnection = () => {
	useEffect(() => {
		centrifuge.connect();
		return () => {
			centrifuge.disconnect();
		};
	}, []);
	return null;
};

const App = () => {
	const router = getRouter({ subDomain, store });

	return (
		<ConfigProvider
			theme={{
				token: {
					fontFamily: 'IBM Plex Sans',
				},
			}}
		>
			<ApolloProvider client={client}>
				<Provider store={store}>
					<CentrifugoProvider client={centrifuge}>
						<CentrifugoConnection />
						<RouterProvider router={router}></RouterProvider>
					</CentrifugoProvider>
				</Provider>
			</ApolloProvider>
		</ConfigProvider>
	);
};

export default App;
